export enum TeamMemberStatus {
  INVITED = 'invited',
  ACTIVE = 'active',
}
